// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3CbHD","consentsList":"PatientConsents_consentsList__7xb3c","consentsListEmpty":"PatientConsents_consentsListEmpty__gONkx"};